import React from "react";

import styled from "react-emotion";

import { Box } from "src/components";

const Iframe = styled.iframe({
  borderWidth: 0,
  width: "100%",
});

const Calculator = ({ height = 750, sourceUrl, title, ...props }) => (
  <Box {...props}>
    <Iframe
      src={`${sourceUrl}&title=hide&info=hide`}
      style={{ height }}
      title={title}
    />
  </Box>
);

export default Calculator;

export const CalculatorFragment = graphql`
  fragment Calculator on ContentfulCalculator {
    id
    __typename
    sourceUrl
    height
    title: name
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/Calculator.js